import {Entidade} from "./Entidade";
import {Entity, PrimaryGeneratedColumn} from "typeorm/browser";
import {Column} from "typeorm";

@Entity("cursodagua")
export class CursoDagua {
  @PrimaryGeneratedColumn("uuid")
  id?: string
  @Column()
  nome?: string
  @Column()
  nomeAbreviado?: string
  @Column()
  tipoTrecho?: string
  @Column()
  regime?: string
  @Column()
  salinidade?: string

  get descricao(): string {
    return this.tipoTrecho + " - " + this.regime + " - " + this.salinidade
  }

}

